// src/store/slices/usersSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import UserService from 'services/UserService';

export const fetchUsers = createAsyncThunk(
    'users/fetchAll',
    async (params, { rejectWithValue }) => {
        try {
            return await UserService.getAll(params);
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al cargar usuarios');
        }
    }
);

export const createUser = createAsyncThunk(
    'users/create',
    async (data, { rejectWithValue }) => {
        try {
            return await UserService.create(data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const updateUser = createAsyncThunk(
    'users/update',
    async ({ id, data }, { rejectWithValue }) => {
        try {
            return await UserService.update(id, data);
        } catch (err) {
            return rejectWithValue(err.response?.data?.errors || err.response?.data?.message);
        }
    }
);

export const deleteUser = createAsyncThunk(
    'users/delete',
    async (id, { rejectWithValue }) => {
        try {
            await UserService.remove(id);
            return id;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || 'Error al eliminar');
        }
    }
);

const usersSlice = createSlice({
    name: 'users',
    initialState: {
        list: [],
        pagination: { current: 1, pageSize: 15, total: 0 },
        loading: false,
        error: null,
    },
    reducers: {
        clearUsersError: (state) => { state.error = null; },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.list = action.payload.data;
                state.pagination = {
                    current: action.payload.meta.current_page,
                    pageSize: action.payload.meta.per_page,
                    total: action.payload.meta.total,
                };
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createUser.fulfilled, (state) => { state.loading = false; })
            .addCase(updateUser.fulfilled, (state) => { state.loading = false; })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.list = state.list.filter((u) => u.id !== action.payload);
            });
    },
});

export const { clearUsersError } = usersSlice.actions;
export default usersSlice.reducer;